import { memo } from 'react';
import type { ReactNode } from 'react';

interface ChartCardProps {
  title: string;
  /** Material symbol name rendered before the title. */
  icon: string;
  /** Extra class(es) appended to `metrics-chart-card`. */
  className?: string;
  /** Extra class(es) appended to `metrics-chart-body`. */
  bodyClassName?: string;
  /** When true the body renders `emptyMessage` instead of the chart. */
  isEmpty?: boolean;
  emptyMessage?: string;
  /** The chart itself. */
  children: ReactNode;
  /** Rendered inside the body after the chart/empty state (e.g. a legend). */
  extra?: ReactNode;
  /** Rendered in the header, opposite the title — e.g. a tab strip. */
  actions?: ReactNode;
}

/**
 * Shared title + body + empty-state scaffolding for the dashboard chart
 * cards (kWh-per-day chart on the Metrics page).
 */
export const ChartCard = memo(function ChartCard({
  title,
  icon,
  className,
  bodyClassName,
  isEmpty = false,
  emptyMessage,
  children,
  extra,
  actions,
}: ChartCardProps) {
  return (
    <div className={`metrics-chart-card${className ? ` ${className}` : ''}`}>
      <div className="metrics-chart-head">
        <h3 className="metrics-chart-title">
          <span className="material-symbols-outlined" aria-hidden="true">{icon}</span>
          {title}
        </h3>
        {actions}
      </div>
      <div className={`metrics-chart-body${bodyClassName ? ` ${bodyClassName}` : ''}`}>
        {isEmpty ? (
          <div className="metrics-chart-empty">{emptyMessage}</div>
        ) : (
          children
        )}
        {extra}
      </div>
    </div>
  );
});

export default ChartCard;
